<template>
  <div align="center" justify="center" class="page mt-3">
    <ValidationObserver
      v-slot="{ handleSubmit }"
    >
      <v-card class="box ma-auto px-6 px-sm-8 py-5 d-flex flex-column justify-space-between  align-center rounded">
        <div class="text">
          <h1 class="mb-3">{{ $t('forgotPassword.title') }}</h1>
        </div>
        <text-field
          v-model="password"
          :rules="{
            required: true,
            min: 4,
          }"
          class="input"
          name="password"
          type="password"
          :placeholder="$t('settings.changePassword.newPassword')"
        >
          <template #prepend-inner>
            <iconLock class="mt-1 mr-1"></iconLock>
          </template>
        </text-field>

        <text-field
          v-model="confirmPassword"
          :rules="{
            required: true,
            min: 4,
            password: '@password'
          }"
          class="input"
          name="password again"
          type="password"
          :placeholder="$t('settings.changePassword.newPassword')"
        >
          <template #prepend-inner>
            <iconLock class="mt-1 mr-1"></iconLock>
          </template>
        </text-field>

        <v-btn class="primary btn-text py-7 mt-2 mb-3" dark @click="handleSubmit(resetPassword)">{{ $t('forgotPassword.resetPassword') }}</v-btn>

      </v-card>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, extend } from 'vee-validate';
import textField from '@/components/base/textField';
import iconLock from '@/static/img/lock.svg';
import toastr from '@/plugins/toastr';

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match',
});

export default {
  name: 'forgotPassword',

  components: {
    ValidationObserver,
    textField,
    iconLock,
  },

  props: {
    token: String,
  },

  data () {
    return {
      password: '',
      confirmPassword: '',
    };
  },

  methods: {
    async resetPassword () {
      await this.$store.dispatch('authorization/RESET_PASSWORD', { password: this.password, token: this.token });
      toastr.success(this.$t('forgotPassword.passwordChanged'));
      this.$router.push({ name: 'signIn' }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background: #fff;
  border: 1px solid #E5E5E5;
  max-width: 330px
}
  .topbar {
    margin-bottom: 50px;
    display: flex;

    .topbar-text {
      // color: #3736a0;
      font-weight: bold;
      display: flex;
      margin-left: 10px;
    }
  }

  .text {
    // color: #3736a0;
    text-align: left;
    // line-height: 1;

    h1 {
      font-weight: 900;
      font-size: 23px;
    }
  }
  .input {
    width: 100%;
  }

  .btn-text {
    width: 100%;
  }
</style>
